module.exports = __webpack_public_path__ + "static/cacircle-39c77fb679c29d669aef633c695594d4.png";